import Konva from 'konva'
import moment from 'moment'

function drawRect (x, width) {
  if (width > 20) {
    width = 20
  }
  return new Konva.Rect({
    name: 'fluidRect',
    x: x,
    y: 0,
    width: width,
    height: 6,
    fillLinearGradientStartPoint: {
      x: 0,
      y: 0
    },
    fillLinearGradientEndPoint: {
      x: 0,
      y: 6
    },
    fillLinearGradientColorStops: [0, '#00C2FF', 0.5, 'white', 1, '#00C2FF'],
    fillEnabled: true
  })
}

function drawFluidRect (group, rectCount, rectWidth, bgWidth) {
  for (let i = 0; i < rectCount; i++) {
    let rect = null
    if (i === rectCount - 1) {
      const w = bgWidth - i * rectWidth * 2
      rect = drawRect(i * rectWidth * 2, w <= 0 ? 0 : w)
    } else {
      rect = drawRect(i * rectWidth * 2, rectWidth)
    }
    group.add(rect)
  }
}

function groupTransform (group) {
  group.on('transform', function () {
    group.scaleY(1)
    const bg = group.findOne('.fluidBackground')
    bg.width(bg.width() * group.scaleX())
    group.find('.fluidRect').forEach(item => item.remove())
    const rectWidth = 20
    let rectCount = 0
    rectCount = Math.floor(bg.width() / (rectWidth * 2)) + 1
    if (bg.width() <= rectWidth * 4) {
      bg.width(rectWidth * 4)
    }
    drawFluidRect(group, rectCount, rectWidth, bg.width())
    group.scaleX(1)
  })
}

const groups = []
const rectWidth = 20
const per = 0.3
let anim = null
let diff = 0

export function removePipeline (pipeline) {
  const i = groups.indexOf(pipeline)
  if (i !== -1) {
    groups.splice(i, 1)
  }
  if (groups.length === 0) {
    anim.stop()
    anim = null
  }
}

export function getFlowingAnimation () {
  if (anim === null) {
    anim = new Konva.Animation(function (frame) {
      if (diff <= 30) {
        diff += frame.timeDiff
        return false
      }
      diff = 0
      if (groups.length === 0 && !anim) {
        anim.stop()
        anim = null
      }
      groups.forEach(group => {
        try {
          const bg = group.findOne('.fluidBackground')
          const rects = group.find('.fluidRect')
          rects.sort((a, b) => a.x() - b.x())
          if (rects[0] === undefined) {
            return
          }
          if (Math.round(rects[0].x()) === rectWidth) {
            const nr = rects[0].clone()
            nr.x(0)
            nr.width(0)
            group.add(nr)
          }
          for (let i = 0; i < rects.length; i++) {
            let rect = rects[i]
            if (rect.x() < bg.width() - rectWidth) {
              if (rect.width() >= rectWidth) {
                rect.width(rectWidth)
                rect.x(rect.x() + per)
              } else {
                rect.width(rect.width() + per)
              }
            } else {
              if (rect.width() <= 0) {
                rect.destroy()
                rect = null
              } else {
                rect.x(rect.x() + per)
                rect.width(rect.width() - per)
              }
            }
          }
        } catch (e) {
          console.log(e)
        }
      })
    }, null)
  }
  return anim
}

export function destroyAnimation () {
  if (anim) {
    anim.stop()
    anim = null
  }
}

export function startFlowingAnimation (group) {
  if (!anim) {
    anim = getFlowingAnimation()
  }
  if (!anim.isRunning()) {
    anim.start()
  }
  groups.push(group)
  groupTransform(group)
  return anim
}

export function drawFlowingPipe (x = 100, y = 100, width = 289) {
  const group = new Konva.Group({
    name: 'flowingPipe',
    x: x,
    y: y,
    draggable: true
  })
  const bg = new Konva.Rect({
    name: 'fluidBackground',
    x: 0,
    y: 0,
    width: width,
    height: 6,
    fill: '#1E6E84'
  })
  group.add(bg)
  let rectCount = 0
  rectCount = Math.floor(bg.width() / 40) + 1
  const rectWidth = 20
  drawFluidRect(group, rectCount, rectWidth, bg.width())
  groupTransform(group)
  return group
}

export function drawDataGroup (x, y, name, value, unit) {
  const a = new Konva.Text({
    name: 'key',
    x: 0,
    y: 0,
    text: name,
    fontSize: 14,
    fontFamily: 'Calibri'
  })
  const b = new Konva.Text({
    name: 'value',
    x: 50,
    y: 0,
    text: value,
    fontSize: 14,
    fontFamily: 'Calibri'
  })
  const c = new Konva.Text({
    name: 'value',
    x: 100,
    y: 0,
    text: unit,
    fontSize: 14,
    fontFamily: 'Calibri'
  })
  const group = new Konva.Group({
    x: x,
    y: y
  })
  group.add(a, b, c)
}

const datetimeGroups = []

let datetimeAnim = null

export function createDatetimeComponent (position) {
  return new Konva.Text({
    name: 'datetime',
    x: position.x,
    y: position.y,
    text: moment().format('YYYY-MM-dd HH:mm:ss dd'),
    fill: '#fff',
    fontSize: 14,
    fontFamily: 'Calibri'
  })
}

export function AddDatetimeToAnim (datetimeComponent) {
  if (!datetimeAnim) {
    datetimeAnim = new Konva.Animation((frame) => {
      datetimeGroups.forEach(datetimeComponent => {
        datetimeComponent.text(moment().format('YYYY-MM-DD HH:mm:ss ddd'))
      })
    })
  }
  datetimeGroups.push(datetimeComponent)
  if (!datetimeAnim.isRunning()) {
    datetimeAnim.start()
  }
}

export function removeDatetimeFromAnim (datetimeComponent) {
  const i = datetimeGroups.indexOf(datetimeComponent)
  if (i !== -1) {
    datetimeGroups.splice(i, 1)
  }
  if (datetimeGroups.length === 0) {
    datetimeAnim.stop()
    datetimeAnim = null
  }
}

export function drawGuides (layer) {
  const line = new Konva.Line({
    points: [-6000, 0, 6000, 0],
    stroke: 'rgb(0, 161, 255)',
    strokeWidth: 1,
    name: 'guid-line',
    dash: [4, 6]
  })
  layer.add(line)
  line.absolutePosition({
    x: 0,
    y: 10
  })
}

export class Originator {
  stage = null
  setStage (stage) {
    this.stage = stage
  }

  getStage () {
    return this.stage
  }
}

export class Manager {
  #history = []
  #originator = null
  constructor (originator) {
    this.#originator = originator
  }

  save () {
    if (this.#originator.stage && this.#history.length <= 2) {
      this.#history.push(this.#originator.getStage())
    } else if (this.#originator.stage && this.#history.length > 2) {
      this.#history.splice(0, 1)
      this.#history.push(this.#originator.getStage())
    }
  }

  back () {
    if (this.#history.length > 1) {
      this.#history.pop()
    }
  }

  getStage (index = -1) {
    if (index === -1) {
      return this.#history[this.#history.length - 1]
    }
    return this.#history[index]
  }
}
